import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { FontSize, FontWeight, Spacing, border, ellipsis } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Role } from "@linkfluence/models/role";
import Portrait from "@radarly/components/portrait/project";
import { tr } from "@radarly/i18n";
import { Project } from "@radarly/models/project";

interface IProps {
  projects: Project[];
  locale: Locale;
}

const getIdFromRole = (role: Role = Role.Reader) =>
  ({
    [Role.Supervisor]: "super_administrator",
    [Role.Admin]: "administrator",
    [Role.Writer]: "writer",
    [Role.Reader]: "reader",
  }[role]);

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  thead {
    font-weight: ${FontWeight.Bold};
    text-align: left;
  }
  tbody {
    font-size: ${FontSize.Medium};
    line-height: 24px;
  }
  th,
  td {
    border-top: 1px solid ${border};
    vertical-align: middle;
    height: 48px;
  }
  th {
    padding: 0 ${Spacing.Medium};
    border: 1px solid ${border};
  }
`;

const Avatar = styled.td`
  padding: 0 8px;
  width: 1px;
`;

const Label = styled.div`
  line-height: 32px;
  vertical-align: middle;
  ${ellipsis(200)};
`;

const RoleLabel = styled.div`
  line-height: 32px;
  vertical-align: middle;
  ${ellipsis(160)};
`;

const RoleCol = styled.td`
  padding-left: ${Spacing.Medium};
`;

const UiKitProfileProjects = ({ projects, locale }: IProps) => (
  <Table>
    <thead>
      <tr>
        <th colSpan={2}>
          {tr(locale, "PROFILE.ACCESS_RIGHTS.COLUMNS.PROJECT")}
        </th>
        <th>{tr(locale, "PROFILE.ACCESS_RIGHTS.COLUMNS.ROLE")}</th>
      </tr>
    </thead>
    <tbody>
      {map(projects, (project) => (
        <tr key={project.id}>
          <Avatar>
            <Portrait
              picture={project.imageUrl}
              isAccessible={project.flags.isAccessible}
              isActive={project.flags.isActive}
            />
          </Avatar>
          <td>
            <Label>{project.label}</Label>
          </td>
          <RoleCol>
            <RoleLabel>
              {tr(
                locale,
                "SETTINGS.MEMBERS.RIGHTS.ROLES_" + getIdFromRole(project.role)
              )}
            </RoleLabel>
          </RoleCol>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default UiKitProfileProjects;
